(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('RecommendPic', RecommendPic);

    RecommendPic.$inject = ['$resource'];

    function RecommendPic ($resource) {
        var resourceUrl =  'manager/' + 'api/recommend-pics/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "batchCreateByStore":{
                method:"GET",
                params:{
                    path:"batchCreateByStore"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "save":{
                method:"POST",
                params:{
                    path:"save"
                }
            },
            "delete":{
                method:"DELETE",
            },
            'update': {
                method:'PUT',
            },
        });
    }
})();
